import { Component, OnInit } from '@angular/core';
export class CarregandoComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-carregando',
  template: `
    <div class="progress">
      <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"
        style="width: 100%">
        Carregando informações
      </div>
    </div>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CarregandoComponent_tsickle_Closure_declarations() {
/** @type {?} */
CarregandoComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CarregandoComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
